import { formatCurrency, formatVND1000 } from '../../../../utils/format';
export const renderStandardChart = (
  dataArray,
  keyY,
  keyX,
  isCurrency = false,
) => {
  if (!dataArray || dataArray.length === 0)
    return (
      <div className="flex h-full items-center justify-center text-slate-500 font-medium">
        Chưa đủ dữ liệu
      </div>
    );

  const data = dataArray.map((d) => parseFloat(d[keyY]));
  const max = Math.max(...data);
  const min = Math.min(...data) * 0.85;
  const range = max - min || 1;
  const color = "#2563eb"; // Blue Primary

  const points = data.map((val, idx) => ({
    x: (idx / (data.length - 1)) * 96 + 2,
    y: 100 - ((val - min) / range) * 80 - 10,
    val,
    label: dataArray[idx][keyX],
  }));
  const polyPoints = points.map((p) => `${p.x},${p.y}`).join(" ");

  return (
    <div className="h-full w-full relative">
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full overflow-visible"
        preserveAspectRatio="none"
      >
        {/* Grid Lines Y */}
        <g stroke="#e2e8f0" strokeWidth="0.5" strokeDasharray="2">
          <line x1="0" y1="10" x2="100" y2="10" />
          <line x1="0" y1="50" x2="100" y2="50" />
          <line x1="0" y1="90" x2="100" y2="90" />
        </g>
        {/* X-Axis Base */}
        <line
          x1="0"
          y1="100"
          x2="100"
          y2="100"
          stroke="#cbd5e1"
          strokeWidth="1"
        />

        {/* Gradient Fill */}
        <defs>
          <linearGradient id={`gradient-${keyY}`} x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>
        <polygon
          points={`0,100 ${polyPoints} 100,100`}
          fill={`url(#gradient-${keyY})`}
        />

        {/* Line & Points */}
        <polyline
          fill="none"
          stroke={color}
          strokeWidth="2"
          points={polyPoints}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {points.map((p, idx) => (
          <circle
            key={idx}
            cx={p.x}
            cy={p.y}
            r="2.5"
            fill="white"
            stroke={color}
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
            className="hover:r-5 transition-all cursor-pointer relative z-20"
          >
            <title>
              {p.label}:{" "}
              {isCurrency ? formatCurrency(p.val) : formatVND1000(p.val)}
            </title>
          </circle>
        ))}
      </svg>
      {/* X-Axis Labels */}
      <div className="absolute bottom-0 left-0 right-0 flex justify-between text-[11px] font-semibold text-slate-500 px-1 mt-4 transform translate-y-full">
        <span>{points[0].label.split(" ").pop()}</span>
        <span>
          {points[Math.floor(points.length / 2)].label.split(" ").pop()}
        </span>
        <span>{points[points.length - 1].label.split(" ").pop()}</span>
      </div>
    </div>
  );
};
